import { render, staticRenderFns } from "./AdministratorMain.vue?vue&type=template&id=39219ea6&scoped=true"
import script from "./AdministratorMain.vue?vue&type=script&lang=js"
export * from "./AdministratorMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39219ea6",
  null
  
)

export default component.exports